import type { SVGProps } from "react";

export default function LightbulbReactionIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="10"
      height="14"
      viewBox="0 0 10 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="Group">
        <path
          id="Vector"
          d="M7.18233 9.82584H2.81909C2.6691 9.82584 2.54639 10.0058 2.54639 10.2258V11.8258H7.45503V10.2258C7.45503 10.0058 7.33232 9.82584 7.18233 9.82584Z"
          fill="currentColor"
        />
        <path
          id="Vector_2"
          d="M3.09179 11.2H2.54639V12.1797C2.54639 12.3144 2.6691 12.4246 2.81909 12.4246H7.18233C7.33232 12.4246 7.45503 12.3144 7.45503 12.1797V11.2H3.09179Z"
          fill="currentColor"
        />
        <path
          id="Vector_3"
          d="M4.28058 12.9903H3.58521C3.86606 13.4287 4.39515 13.7251 5.00058 13.7251C5.60601 13.7251 6.13496 13.4287 6.41595 12.9903H4.28058Z"
          fill="currentColor"
        />
        <path
          id="Vector_4"
          d="M8.01392 1.35959C7.14395 0.612576 6.0014 0.228038 4.79322 0.279541C2.55438 0.372588 0.729798 2.02088 0.64004 4.03423C0.596458 5.00405 0.953633 5.94952 1.64355 6.69651C2.3308 7.4362 2.73705 8.36437 2.80521 9.33672H3.90967V6.50002H3.50061C2.97431 6.50002 2.54615 6.01315 2.54615 5.54047C2.54615 5.06779 2.97431 4.68325 3.50061 4.68325C4.02691 4.68325 4.45507 5.06779 4.45507 5.54047V5.90785H5.54588V5.54047C5.54588 5.06779 5.97404 4.68325 6.50034 4.68325C7.02664 4.68325 7.4548 5.06779 7.4548 5.54047C7.4548 6.01315 7.02664 6.50002 6.50034 6.50002H6.09129V9.33672H7.19575C7.2666 8.37661 7.68113 7.45084 8.40661 6.6426C9.02285 5.9495 9.36375 5.08005 9.36375 4.19341C9.36375 3.11336 8.88388 2.10664 8.01392 1.35959Z"
          fill="currentColor"
        />
        <path
          id="Vector_5"
          d="M4.45532 6.5H5.54613V9.34H4.45532V6.5Z"
          fill="currentColor"
        />
        <path
          id="Vector_6"
          d="M3.50061 5.17322C3.27429 5.17322 3.09155 5.33734 3.09155 5.5406C3.09155 5.74386 3.27429 5.90798 3.50061 5.90798H3.90966V5.5406C3.90966 5.33734 3.72692 5.17322 3.50061 5.17322Z"
          fill="currentColor"
        />
        <path
          id="Vector_7"
          d="M6.90942 5.5406C6.90942 5.33734 6.72668 5.17322 6.50036 5.17322C6.27404 5.17322 6.09131 5.33734 6.09131 5.5406V5.90798H6.50036C6.72668 5.90798 6.90942 5.74386 6.90942 5.5406Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
